module.exports = __webpack_public_path__ + "static/0009-0a119b12fa540571020ccb57ddb5ed42.jpg";